<template>
    <div v-if="place" class="editPlace container">
        <h1 >Edit{{this.$route.params.place_slug}}</h1>
      
         <form @submit.prevent="editPlace">
            <div class="field ">
                <label for="title">Name:</label>
                <input type = "text" name = "name" v-model="place.name">
            </div>
             <div class="field ">
                <label for="type">Type:</label>
                <input type = "text" name = "type" v-model="place.type">
            </div>
             <div class="field ">
                <label for="type">Description:</label>
                 <textarea name = "description" v-model="place.description"></textarea> 
            </div>
             <div class="field ">
                <label for="location">Location:</label>
                <input type = "text" name = "location" v-model="place.location">
            </div>
            <div class="field ">
              <input type="file" name="photo" ref ="fileInput" @change="onFileSelected" >
            </div>  
               
            <p class = "red-text">{{feedback}}</p>
             <div class="field ">
               <button class = "btn orange">Edit Place</button>
            </div>
        </form>
        
    </div>
</template>
<script>
import firebase from "firebase"
import db from "@/firebase/init"
import slugify from "slugify"
export default {
    name:"EditPlace",
    data(){
        return{
            place:null,
            feedback:null,
        }
    },
    methods:{
          onFileSelected(event){
            this.image = event.target.files[0]
        },
        editPlace(){
            var image
            if(this.place.name && this.place.type ){
                    this.place.slug = slugify(this.place.name,{
                    replacement:"-",
                    remove:/[$*_+~.()'"!\-:@]/g,
                    lower:true
                    })

                // delete file
                if(this.image){
                    var storage = firebase.storage();
                    var removeRef = firebase.storage().ref("places/" + this.place.imageName + ".jpg")
                        removeRef.delete().then(function() {
                        console.log("File deleted successfully")
                    }).then(() => {
                        var file = this.image
                        
                        var storage = firebase.storage();
                        var storageRef = firebase.storage().ref("places/"+ this.place.name  +".jpg" )
                        storageRef.put(file).then(function(snapshot) {
                        console.log('Uploaded a blob or file!');
                        }).then(()=>{
                        storageRef.getDownloadURL().then(function(url) {
                        image = url
                            }).then(()=> {

                            console.log(image)
                        db.collection("places").doc(this.place.id).update({
                        
                            name : this.place.name,
                            type : this.place.type,
                            slug:this.place.slug,
                            location : this.place.location,
                            imageName:this.place.name,
                            imageUrl:image

                        
                        }).then(() => {
                        
                            
                            this.$router.push({name:"Index"})
                        }).catch(err => {
                            console.log(err)
                        })
                        }) })
                        })
                    }else{
                         db.collection("places").doc(this.place.id).update({
                        
                            name : this.place.name,
                            type : this.place.type,
                            slug:this.place.slug,
                            location : this.place.location,
                            imageName:this.place.name
                           

                        
                        }).then(() => {
                        
                            
                            this.$router.push({name:"Index"})
                        }).catch(err => {
                            console.log(err.message)
                        })
                    }

            }else{
                this.feedback = "all fields must be filed"
            }
            

        }
       
    },
     created(){
            let ref = db.collection("places").where("slug","==", this.$route.params.place_slug)
            ref.get()
            .then((snapshot) => {
                snapshot.forEach((doc)=> {
                   this.place = doc.data()
                   this.place.id = doc.id
                })
            })
            
        },
      
}
</script>
<style>

</style>





// WEBPACK FOOTER //
// src/components/EditPlace.vue